import React from 'react';
import { NavLink } from 'react-router-dom';
import BottomSheet from '../BottomSheet';
import Icon from './Icon';
import { moreLinks } from './navConfig';

const MoreSheet = ({ isOpen, onClose, user, onLogout }) => (
  <BottomSheet isOpen={isOpen} onClose={onClose} title="More">
    <div className="flex items-center gap-3 pb-4 mb-2 border-b border-slate-100">
      <div className="w-11 h-11 rounded-full bg-slate-100 flex items-center justify-center font-semibold text-slate-600">
        {(user?.name || user?.email || 'U').charAt(0).toUpperCase()}
      </div>
      <div className="min-w-0">
        <p className="text-sm font-semibold text-slate-900 truncate">{user?.name || user?.email}</p>
        <p className="text-xs text-slate-500 capitalize">{(user?.role || 'user').replace('_', ' ')}</p>
      </div>
    </div>
    <ul className="divide-y divide-slate-100">
      {moreLinks(user).map((l) => (
        <li key={l.to}>
          <NavLink to={l.to} onClick={onClose}
            className={({ isActive }) => `flex items-center gap-3 h-12 text-[15px] ${isActive ? 'text-blue-600 font-semibold' : 'text-slate-800'}`}>
            <Icon name={l.icon} className="w-5 h-5 text-slate-400" />
            <span className="flex-1">{l.label}</span>
            <Icon name="chevron" className="w-4 h-4 text-slate-300" />
          </NavLink>
        </li>
      ))}
    </ul>
    <button type="button" onClick={onLogout}
      className="mt-4 w-full h-12 rounded-xl bg-red-50 text-red-600 text-[15px] font-medium flex items-center justify-center gap-2">
      <Icon name="logout" className="w-5 h-5" /> Log out
    </button>
  </BottomSheet>
);

export default MoreSheet;
